import { getCookie, setCookie, ENDLESS_COOKIE_CONFIG } from './cookies'
import configuration from './configuration'

const { PAYPER_EVENTS_ENDPOINT } = configuration

const configured = Boolean(PAYPER_EVENTS_ENDPOINT)

export interface BaseParams {
  userSub?: string
  mediaId?: string
  articleId?: string
}

let baseParams: BaseParams = {}

export enum Event {
  PAGE_VIEW_ARTICLE = 'pmg_article_page_view',
  PAGE_VIEW_MEDIA = 'pbar_media_page_view',
  CLICK_MENU = 'pbar_click_menu',
  SEARCH = 'pbar_search',
  CLOSE_MODAL = 'pbar_close_modal',
  CLICK_ARTICLE = 'pbar_click_article',
  SHOW_BANNER = 'pbar_show_banner',
  CLOSE_BANNER = 'pbar_close_banner',
  ERROR_REFRESH = 'pbar_error_refresh',
  ERROR_AUTH_REQUEST = 'pbar_error_auth_request',
}

type EventParams<K extends Event> = {
  [P in K]: BaseParams
}

const ANALYTICS_COOKIE = '_ga'
const PAYPER_ANALYTICS_COOKIE = '_pa'

const generateClientId = () => {
  const part1 = Math.floor(Math.random() * 1000000000) // Random number up to 9 digits
  const part2 = Math.floor(Math.random() * 10000000000) // Random number up to 10 digits
  return `${part1}.${part2}`
}

const getClientId = (): string | null => {
  const rawGaValue = getCookie(ANALYTICS_COOKIE)
  if (rawGaValue) {
    return rawGaValue.split('.').slice(-2).join('.')
  }
  let payperClientId = getCookie(PAYPER_ANALYTICS_COOKIE)

  if (!payperClientId) {
    payperClientId = generateClientId()
    setCookie(PAYPER_ANALYTICS_COOKIE, payperClientId, ENDLESS_COOKIE_CONFIG)
  }
  return payperClientId
}

export const updateBaseParams = (params: Partial<BaseParams>) => {
  baseParams = { ...baseParams, ...params }
}

export const dispatchEvent = async <T extends Event>(
  name: T,
  params?: EventParams<T>[T],
) => {
  if (import.meta.env.VITE_ENV === 'localhost') return

  const eventParams = {
    ...(params ?? {}),
    ...baseParams,
  }
  if (!configured) {
    return Promise.resolve()
  }

  try {
    await fetch(`${PAYPER_EVENTS_ENDPOINT}/set-event`, {
      method: 'POST',
      body: JSON.stringify({
        client_id: getClientId(),
        events: [{ name, params: eventParams }],
      }),
    })
  } catch (error) {
    console.error('Payper-Bar: Error sending analytics event', { name, error })
  }
}
